import { render } from "./ConfirmEmailView.vue?vue&type=template&id=3fab6c52&scoped=true"
import script from "./ConfirmEmailView.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailView.vue?vue&type=script&lang=js"

import "./ConfirmEmailView.vue?vue&type=style&index=0&id=3fab6c52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fab6c52"]])

export default __exports__